import { render } from "./portfolio.vue?vue&type=template&id=e9f78270&scoped=true"
import script from "./portfolio.vue?vue&type=script&lang=js"
export * from "./portfolio.vue?vue&type=script&lang=js"

import "./portfolio.vue?vue&type=style&index=0&id=e9f78270&scoped=true&lang=css"

import exportComponent from "C:\\Users\\NASTYFACT\\Desktop\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9f78270"]])

export default __exports__